<template>
    <button class="go-back" @click="$router.back()"><img src='../assets/chevron-left-solid.png' class="back_arrow" /><span>indietro</span>
    </button>
</template>
